import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
import { Country, TeamRole } from "../../../../../../shared/constants/Constant";
import "../../../../../dashboard/containers/account/containers/index-team-profile/styles.scss";
import { useHistory, useParams } from "react-router-dom";
import { useFirestore, useFunctions } from "reactfire";
import IconButton from "../../../../../../shared/components/ui/icon-button/IconButton";
import { FaEye } from "react-icons/fa";
import { Line } from "rc-progress";
import {
  SubsectionStatus,
  useAppUser,
  WorkshopProgress,
} from "../../../../../../contexts/user-context/UserContext";
import UserNotification from "../../../../../../shared/components/Notification/UserNotification";
import { ClipLoader } from "react-spinners";
import { useAppContext } from "../../../../../../contexts/app-context/AppContext";
import {
  useWorkshops,
  Workshop,
} from "../../../../../../contexts/workshops-context/WorkshopsContext";
import { DashboardAccountsPages } from "../../containers/Account";
import { DashboardTeamsPages } from "../../../teams/containers/TeamRoutes";

interface TeamMember {
  memberId?: string;
  fullName?: string;
  name?: string;
  email?: string;
  university?: string;
  state?: string;
  role?: TeamRole;
  contact?: string;
  country?: Country;
  createdAt?: Date;
  updatedAt?: Date;
}

const initTeam: Team = {
  teamID: "",
  teamName: "",
  teamDetails: "",
  active: false,
  teamProgres: "",
  teamMembersEmails: [],
  country: undefined,
  importance: "",
  industries: [],
  pitchLink: "",
  projectName: "", //not on teams collection
  projectProgress: "",
  proposalLink: "",
  solvingApproach: "",
  solvingProblem: "",
  stage: "Ideation",
  projectTheme: [],
  fullName: "",
  email: "",
  contact: "",
  placeOfResidence: "",
  whoYouAre: "",
  whatYouAreStudying: "",
  cvLink: "",
  motivation: "",
  commitment: "",
  pastExperience: "",
  members: [],
};

interface Member {
  id: string;
  workshopProgress: WorkshopProgress[];
}

interface Team {
  teamID: string;
  teamName: string;
  active: boolean;
  teamDetails: string;
  teamProgres: string;
  teamMembersEmails?: string[];
  country: Country | undefined;
  importance?: string;
  industries?: string[];
  pitchLink?: string;
  projectName?: string; //not in teams collection
  projectProgress?: string;
  proposalLink?: string;
  solvingApproach?: string;
  solvingProblem?: string;
  stage?:
    | "Ideation"
    | "Idea Validated and Market Analysed"
    | "Business Plan Formulation"
    | "MVP launched"
    | "Early Revenue"
    | "Growth and Expansions";
  projectTheme?: string[];
  fullName?: string;
  email?: string;
  dob?: Date;
  contact?: string;
  placeOfResidence?: string;
  whoYouAre?: string;
  whatYouAreStudying?: string;
  cvLink?: any;
  motivation?: string;
  commitment?: string;
  pastExperience?: string;
  members: Member[];
}

const initialMembers: TeamMember[] = [];

const TeamProfileComponent = () => {
  const store = useFirestore();
  const appUser = useAppUser();
  const history = useHistory();
  const { id: teamId } = useParams() as any;
  const app = useAppContext();
  const activeRef = useFunctions().httpsCallable("updateTeamActiveStatus");

  const [team, setTeam] = useState(initTeam);
  const [members, setMembers] = useState(initialMembers);
  const workshopContext = useWorkshops();

  const [workshops, setWorkshops] = useState<Workshop[]>([]);
  const [state, setState] = useState({ loading: false });
  const [workshopProgress, setworkshopProgress] = useState<{
    completion: number;
    points: number;
    workshops: { id: string; name: string; progress: number; points: number }[];
  }>({ completion: 0, points: 0, workshops: [] });

  useEffect(() => {
    setTeam((ps) => ({ ...ps, teamID: teamId }));
  }, [teamId]);

  useEffect(() => {
    let unset: any;
    if (unset) unset();
    if (team.teamID && team.teamID !== "") {
      unset = store
        .collection("teams")
        .doc(team.teamID)
        .onSnapshot((data) => {
          const teamName = data.get("name");
          const teamDetails = data.get("proposalLink");
          const teamProgress = data.get("projectProgress");
          const members: any[] = data.get("members");
          const country = data.get("country");
          const importance = data.get("importance");
          const industries = data.get("industries");
          const pitchLink = data.get("pitchLink");
          const projectName = data.get("project");
          const projectProgress = data.get("projectProgress");
          const proposalLink = data.get("proposalLink");
          const solvingApproach = data.get("solvingApproach");
          const solvingProblem = data.get("solvingProblem");
          const stage = data.get("stage");
          const projectTheme = data.get("projectTheme");
          const active = data.get("active");
          setTeam((ps) => ({
            ...ps,
            teamName: teamName,
            teamDetails: teamDetails,
            teamProgres: teamProgress,
            teamMembersEmails: members.map((member) => member.email),
            country: country,
            importance: importance,
            industries: industries,
            pitchLink: pitchLink,
            projectName: projectName,
            projectProgress: projectProgress,
            proposalLink: proposalLink,
            solvingApproach: solvingApproach,
            solvingProblem: solvingProblem,
            stage: stage,
            projectTheme: projectTheme,
            active: active,
            members,
          }));
        });
    }
    return unset;
  }, [store, team.teamID]);

  useEffect(() => {
    if (team.country) {
      setWorkshops(
        workshopContext.allWorkshops.filter(
          (w) => w.active && w.country === team.country
        )
      );
    }
  }, [team.country, workshopContext.allWorkshops]);

  useEffect(() => {
    let mounted = true;
    if (
      team.teamMembersEmails &&
      team.teamMembersEmails?.length > 0 &&
      mounted
    ) {
      store
        .collection("members")
        .where("email", "in", team.teamMembersEmails)
        .onSnapshot((snapshot) => {
          setMembers((ps) => {
            const x = snapshot.docs.map((doc) => {
              return {
                ...doc.data(),
                memberId: doc.id,
              };
            });
            return x;
          });
        });
    }

    return () => {
      mounted = false;
    };
  }, [team.teamMembersEmails, store]);

  useEffect(() => {
    if (
      !appUser.userRole.isModerator &&
      appUser.userRole.isMember &&
      team &&
      team.teamID &&
      team.teamID !== "" &&
      appUser.teamIds.filter((s) => s === team.teamID).length === 0
    ) {
      history.push("/dashboard/account");
    }
  }, [
    appUser.userRole.isModerator,
    appUser.userRole.isMember,
    team,
    team.teamID,
    appUser.teamIds,
    history,
  ]);

  useEffect(() => {
    let available = true;
    if (available) {
      let marks: { id: string; count: number; status: SubsectionStatus }[] = [];

      team.members.forEach((m) => {
        m.workshopProgress?.forEach((m) => {
          const [workshop] = workshops.filter((w) => w.id === m.workshopId);
          const u_subsectons = m.subsectionsProgress.filter(
            (v, i, a) =>
              a.findIndex((t) => t.subsectionId === v.subsectionId) === i
          );
          const count = u_subsectons.filter(
            (s) =>
              s.status === SubsectionStatus.DONE &&
              workshop?.workshopSections.filter(
                (ww) => ww.id === s.subsectionId
              ).length > 0
          ).length;
          marks.push({
            id: m.workshopId,
            count: count,
            status: m.status,
          });
        });
      });

      // let doneWorkshops = marks.filter((s) => s.status === SubsectionStatus.DONE);
      // const allWorkshops = workshops;

      // doneWorkshops = doneWorkshops.filter(
      //   (v, i, a) => a.findIndex((t) => t.id === v.id) === i
      // );

      let overall = 0;
      // overall = Math.round((doneWorkshops.length / allWorkshops.length) * 100);

      let teamPints: number = 0;
      // let overall: number = 0;
      const w_list: {
        id: string;
        name: string;
        progress: number;
        points: number;
      }[] = [];
      marks?.forEach((m) => {
        const [workshop] = workshops.filter((w) => w.id === m.id);
        if (workshop) {
          const points = workshop.points;
          const totalSubsectionCount = workshop.workshopSections.length;
          const completedSubsectionCount = m.count || 0;

          if (completedSubsectionCount > 0) {
            teamPints += Math.round(
              (completedSubsectionCount / totalSubsectionCount) * points
            );

            w_list.push({
              id: workshop.id,
              name: workshop.title,
              progress: Math.round(
                (completedSubsectionCount / totalSubsectionCount) * 100
              ),
              points: Math.round(
                (completedSubsectionCount / totalSubsectionCount) * points
              ),
            });
          }
        }
      });

      let workshopTotalPoints: number = 0;
      workshops
        .map((w) => w.points)
        .forEach((p) => {
          workshopTotalPoints = +workshopTotalPoints + +p;
        });
      workshopTotalPoints *= team.members.length;
      overall = Math.round((teamPints / workshopTotalPoints) * 100);

      let new_w_list: {
        id: string;
        name: string;
        progress: number;
        points: number;
      }[] = [];

      w_list.forEach((w) => {
        if (new_w_list.filter((x) => x.id === w.id).length === 0) {
          new_w_list.push(w);
        } else {
          let [a_workshop] = new_w_list.filter((x) => x.id === w.id);
          a_workshop.points = a_workshop.points + w.points;
          a_workshop.progress = a_workshop.progress + w.progress;
        }
      });

      new_w_list.forEach((nwl) => {
        nwl.progress = Math.round(nwl.progress / team.members.length);
      });

      if (overall && teamPints)
        setworkshopProgress({
          completion: overall,
          points: teamPints,
          workshops: new_w_list,
        });
    }
    return () => {
      available = false;
    };
  }, [workshops, team.members]);

  const updateTeamActiveStatus = (newActiveStatus: boolean) => {
    const ActiveStatusData = {
      teamID: team.teamID,
      active: newActiveStatus,
    };

    activeRef(ActiveStatusData)
      .then((data: any) => {
        setTeam({ ...team, active: newActiveStatus });
        UserNotification({
          isSuccess: true,
          message:
            "Team " +
            (newActiveStatus ? "activated " : "deactivated ") +
            "successfully!",
        });
      })
      .catch((error: any) => {
        UserNotification({
          isSuccess: false,
          message:
            "Team " +
            (newActiveStatus ? "activation " : "deactivation ") +
            "failed!\nPlease check your connection.",
        });
      })
      .finally(() => {
        setState({ ...state, loading: false });
      });
  };

  const getCountryString = (c: Country | undefined) => {
    console.log("country:", c);
    switch (c) {
      case Country.BOSNIA:
        return "Bosnia and Herzegovina";
      case Country.JAMAICA:
        return "Jamaica";
      case Country.MALAYSIA:
        return "Malaysia";
      case Country.SRI_LANKA:
        return "Sri Lanka";
      case Country.INDIA:
        return "India";
      case Country.INDONESIA:
        return "Indonesia";
      default:
        return "";
    }
  };

  return (
    <Container fluid className="team-profile-container">
      <Row>
        <Col xs={6}>
          <div className="mb-3">
            <label className="font-weight-bold normal-label">Team Name :</label>
            <label className="pl-3 normal-label">{team.teamName}</label>
          </div>
          <div className="mb-3">
            <label className="font-weight-bold normal-label">Country :</label>
            <label className="pl-3 normal-label">
              {getCountryString(team.country)}
            </label>
          </div>
          <div className="mb-3">
            <label className="font-weight-bold normal-label">Status :</label>
            {team.active ? (
              <label className={"pl-3 normal-label active"}>Active</label>
            ) : (
              <label className={"pl-3 normal-label inactive"}>Inactive</label>
            )}
            {appUser.userRole.isModerator &&
              (team.active ? (
                <>
                  {state.loading ? (
                    <span className="ml-3">
                      <ClipLoader size={25} color={"#006699"} loading={true} />
                    </span>
                  ) : (
                    <button
                      className="ml-3 btn-deactivate"
                      onClick={() => {
                        updateTeamActiveStatus(false);
                        setState({ ...state, loading: true });
                      }}
                    >
                      Deactivate
                    </button>
                  )}
                </>
              ) : (
                <>
                  {state.loading ? (
                    <span className="ml-3">
                      <ClipLoader size={25} color={"#006699"} loading={true} />
                    </span>
                  ) : (
                    <button
                      className="ml-3 btn-activate"
                      onClick={() => {
                        updateTeamActiveStatus(true);
                        setState({ ...state, loading: true });
                      }}
                    >
                      Activate
                    </button>
                  )}
                </>
              ))}
          </div>
          <div className="mb-3">
            <button
              className="app-button"
              onClick={() => {
                if (appUser.userRole.isModerator) {
                  history.push(
                    DashboardTeamsPages.TEAM_PROFILE_EDIT.replace(
                      ":id",
                      team.teamID
                    )
                  );
                } else {
                  history.push(
                    DashboardAccountsPages.ACCOUNT_COMPANY.replace(
                      ":id",
                      team.teamID
                    )
                  );
                }
              }}
            >
              Edit Profile
            </button>
          </div>
        </Col>
        <Col xs={6} className="text-right" style={{ paddingRight: "20px" }}>
          <div className="mb-3">
            <label className="font-weight-bold sized-label">
              Overall Workshop Completion :
            </label>
            <label className="pl-3 percentage">
              {workshopProgress.completion}%
            </label>
          </div>
          <div className="mb-3">
            <label className="font-weight-bold sized-label">
              Overall Team Points :
            </label>
            <label className="pl-3 sized-label font-weight-bold">
              {workshopProgress.points}
            </label>
          </div>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xs={12} className="d-flex">
          <div className="flex-title">
            <label
              className="font-weight-bold normal-label"
              style={{ paddingTop: "10px" }}
            >
              Team Member List :
            </label>
          </div>
          <div
            className="flex-content"
            style={{ flex: "1", paddingLeft: "20px", paddingRight: "20px" }}
          >
            <table className="tbl-team-members ml-3 w-100">
              <thead>
                <tr>
                  <th>Full Name</th>
                  <th>Email Address</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {members.filter &&
                  members
                    ?.filter((member) => member.role === TeamRole.LEADER)
                    .map((member, index) => (
                      <tr key={index}>
                        <td style={{ verticalAlign: "top" }}>
                          <label className="normal-label">
                            {member.fullName}
                          </label>
                        </td>
                        <td
                          className="normal-label"
                          style={{ verticalAlign: "top" }}
                        >
                          {member.email}
                        </td>
                        <td>
                          <IconButton
                            color="#006699"
                            size="sm"
                            onClick={() => {
                              if (appUser.userRole.isModerator) {
                                app.pushBackURL(
                                  "/dashboard/teams/" + team.teamID
                                );
                                history.push(
                                  "/dashboard/teams/members/" + member.memberId
                                );
                              } else if (appUser.userRole.isMember) {
                                app.pushBackURL(
                                  "/dashboard/account/teams/" + team.teamID
                                );
                                history.push(
                                  "/dashboard/account/members/" +
                                    member.memberId
                                );
                              }
                            }}
                          >
                            <FaEye />
                          </IconButton>
                        </td>
                      </tr>
                    ))}
                {members.filter &&
                  members
                    ?.filter((member) => member.role === TeamRole.MEMBER)
                    .map((member, index) => (
                      <tr key={index}>
                        <td style={{ verticalAlign: "top" }}>
                          <label className="normal-label">
                            {member.fullName}
                          </label>
                        </td>
                        <td
                          className="normal-label"
                          style={{ verticalAlign: "top" }}
                        >
                          {member.email}
                        </td>
                        <td>
                          <IconButton
                            color="#006699"
                            size="sm"
                            onClick={() => {
                              if (appUser.userRole.isModerator) {
                                app.pushBackURL(
                                  "/dashboard/teams/" + team.teamID
                                );
                                history.push(
                                  "/dashboard/teams/members/" + member.memberId
                                );
                              } else if (appUser.userRole.isMember) {
                                app.pushBackURL(
                                  "/dashboard/account/teams/" + team.teamID
                                );
                                history.push(
                                  "/dashboard/account/members/" +
                                    member.memberId
                                );
                              }
                            }}
                          >
                            <FaEye />
                          </IconButton>
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
      {workshopProgress &&
      workshopProgress.workshops &&
      workshopProgress.workshops.length ? (
        <Row className="mt-5">
          <Col xs={12} className="d-flex">
            <div className="flex-title">
              <label
                className="font-weight-bold normal-label"
                style={{ paddingTop: "23px" }}
              >
                Workshops taken :
              </label>
            </div>
            <div className="flex-content" style={{ flex: "1" }}>
              <table className="tbl-team-members ml-3 w-100">
                <tbody>
                  {workshopProgress.workshops.map((w, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          width: "30%",
                          verticalAlign: "top",
                          // color: "#646464",
                          paddingTop: "1.4rem",
                          paddingBottom: "1.4rem",
                        }}
                      >
                        {w.name}
                      </td>
                      <td
                        style={{ width: "50%", verticalAlign: "top" }}
                        className="py-4"
                      >
                        <div className="xstudent-progress-bar">
                          <label className="pcntg" style={{ fontSize: "14px" }}>
                            {w.progress}%
                          </label>
                          <div>
                            <Line
                              percent={w.progress}
                              strokeWidth={1}
                              trailWidth={1}
                              strokeColor="#2ecc71"
                              trailColor="#f2f2f2"
                            />
                          </div>
                        </div>
                      </td>
                      <td
                        style={{
                          width: "40%",
                          verticalAlign: "top",
                          fontSize: "20px",
                          fontWeight: "bold",
                          paddingLeft: "40px",
                          // color: "#646464",
                          paddingTop: "1.2rem",
                          paddingBottom: "1.4rem",
                        }}
                      >
                        Points : {w.points}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default TeamProfileComponent;
